import { render, staticRenderFns } from "./AuditAsignacionForm.vue?vue&type=template&id=2ba085ca&scoped=true&"
import script from "./AuditAsignacionForm.vue?vue&type=script&lang=js&"
export * from "./AuditAsignacionForm.vue?vue&type=script&lang=js&"
import style0 from "./AuditAsignacionForm.vue?vue&type=style&index=0&id=2ba085ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba085ca",
  null
  
)

export default component.exports